var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlane3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206.52 75.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: .75px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.73,24.61c1.39-5,2.75-10.01,4.16-15,.71-2.5,1.5-4.98,2.41-7.94-3.73-.26-7.16-.85-10.52-.57-1.55.13-3,1.93-4.42,3.06-1.26,1-2.43,2.12-3.64,3.18,3.97-7,10.64-9.08,19.79-5.87-2.59,7.71-5.19,15.42-7.78,23.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.63,30.89c-2.35.52-4.68,1.41-7.04,1.5-6.1.21-12.2.07-18.36.7,19.48,2,38.95,4,58.55,6.02.83-2.39,1.79-5.12,2.75-7.86-.24,1.34-.63,2.68-.67,4.03-.06,1.92.14,3.85.28,6.84-3.27,1.06-7.79,2.65-12.38,4-18.99,5.58-38,11.1-57.01,16.6-1.06.31-2.21.44-3.32.44-30.71-.03-61.42.1-92.12-.29-7.8-.1-15.59-1.79-23.36-2.9-1.22-.17-2.32-1.13-3.48-1.73,11.81,2.89,23.83,4.02,35.96,4.11,9.1.07,18.21.01,26.75.01-5.62-2.38-12.24-3.27-19-3.85-4.35-.38-8.65-1.42-12.97-2.16,11.07,1.28,22.11,2.95,33.74,2.02q-2.9-2.68-.65-4.92l-.08-.07c-.22.9-.44,1.8-.81,3.36,3.94.88,7.63,1.71,11.94,2.67h-16.77c12.76,4.93,46.61,4.85,52.8-.71h-9.8c.03-.13.05-.27.08-.4,4.18-1.26,8.36-2.51,12.54-3.77-.1-.45-.21-.9-.31-1.34-4.53-.71-9.06-1.37-13.58-2.14-7.02-1.19-14.02-2.45-21.03-3.68l-.04.09c8.26,1.11,16.52,2.22,24.78,3.33,2.71.37,5.43.67,8.12,1.16,1.12.2,2.16.8,4.18,1.58-2.39,1.58-3.97,2.62-5.64,3.73.76.84,1.58,1.74,2.58,2.85-1.14.83-1.96,1.43-2.78,2.03.06.3.12.6.18.9,4.99-.68,10.15-.78,14.95-2.14,21.34-6.07,42.57-12.49,63.84-18.8.66-.2,1.3-.47,1.94-.71,0-.38-.01-.76-.02-1.14-18.66-1.9-37.31-3.9-55.98-5.69-28.06-2.69-56.17-1.35-84.26-.74-3.41.07-6.76,2.78-10.14,4.26,3.16-4,7.48-5.4,12.38-5.45,31.58-.32,63.16-.61,94.74-.97,2.84-.03,5.68-.51,8.53-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.69,40.63c-1.33,2.27-3.4,2.73-5.91,3-12.19,1.32-23.97,4.17-34.79,10.21,2.41-1.58,4.62-3.87,7.27-4.61,8.61-2.41,17.38-4.22,26.07-6.35,2.49-.61,4.91-1.49,7.36-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.32,53.46c1.25-1.73,2.5-3.46,3.95-5.47-14.76-1.87-29.35-1.88-43.78,2.1,3.43-1.09,6.82-2.87,10.31-3.13,8.65-.66,17.35-.74,26.04-.83,5.11-.05,10.23.28,15.35.54,1.03.05,2.04.52,3.06.8,0,0,.04-.09.04-.09-6.19-.92-10.88,1.89-15.05,6.02l.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.07,50c-.29.26-.47.61-.66.95-.23.41-.48.81-.74,1.2-.13.19-.1.16-.24.35-.07.11-.14.25-.16.38-.02.12.16.22.25.25.1.04.39.16.49.2.23.1.1.04.33.13.48.18.96.33,1.44.49.82.26,1.65.49,2.46.77.87.3,1.74.6,2.61.9.42.14.84.29,1.26.43.38.13.86.4,1.25.43-.91-.07-1.81-.16-2.71-.28s-1.79-.28-2.67-.51-1.76-.54-2.59-.93-1.69-.92-2.44-1.52c-.46-.36-.89-.76-1.3-1.18l3.42-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.92,4l-24.26,22.28s-7.45,5.5-13.28,5.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.88 48.89 10.2 57.66 19.77 57.66 22.72 55.41 22.72 45.85 10.88 48.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.77 46.69 37.77 43.04 44.1 45.85 50.42 37.97 48.31 35.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.35 45.85 53.38 37.27 63.5 37.27 63.5 45.85 46.35 45.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.74,
    y: 37.27,
    width: 10.69,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.22,
    y: 37.27,
    width: 12.94,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.08,
    y: 37.27,
    width: 12.94,
    height: 8.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "115.11 51.75 115.11 34.74 128.89 34.74 128.89 58.64 116.66 58.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.11,
    y1: 47.68,
    x2: 128.89,
    y2: 47.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.08,
    y: 37.27,
    width: 9.98,
    height: 8.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.55,45.85v-8.58s9.43.48,9.84,4.29c.37,3.45-9.84,4.29-9.84,4.29Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.67,
    y1: 48.14,
    x2: 34.67,
    y2: 55.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.77,
    y1: 46.69,
    x2: 40.77,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.27,
    y1: 54.05,
    x2: 39.74,
    y2: 54.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.27,
    y1: 50.58,
    x2: 39.74,
    y2: 50.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.52,
    y1: 58.64,
    x2: 65.52,
    y2: 46.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "92.42 62.96 92.42 60.61 96.55 60.61 114.55 60.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71,50.58s12.86-1.66,16.69,0c3.16,1.37,9.42,10.03,9.42,10.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.42,48.89c0,4.89,15.66,11.72,15.66,11.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.05 61.27 89.05 58.64 83.24 58.64 83.24 61.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.02,
    y1: 26.27,
    x2: 167.61,
    y2: 36.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "179.42 37.27 198.17 5.11 196.67 .14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "200.99 15.71 198.17 15.71 193.95 29.86 196.95 30.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.89,35.86l-25.22,4.59s-1.22,1.31.47,1.5,24.75.38,24.75.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.95,
    cy: 71.36,
    r: 3.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 86.14,
    cy: 69.95,
    r: 5.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane3);
export default __webpack_public_path__ + "static/media/plane3.b2c136211466ae43d3212d2c25598626.svg";
export { ForwardRef as ReactComponent };